// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"V8-z","disabled":"W8-z","label":"X8-z"};